import { MINUTES_PER_STEP } from "./constants";

export const formatStepTime = (step: number): string => {
  const normalized = Math.max(0, step % 288);
  const minutes = normalized * MINUTES_PER_STEP;
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};
